// Sentry (frontend). Imported as the very first line of main.tsx so it can
// install its global error/rejection handlers before anything else runs.
//
// No-op when VITE_SENTRY_DSN is unset: Sentry.init() is simply never called,
// so nothing is sent anywhere and the app behaves exactly as before. No
// Sentry account has been created and no DSN has been generated by this
// change — see OBSERVABILITY.md at the repo root for the manual setup steps.
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
    // Errors are always captured; this only controls performance trace
    // sampling. Kept low by default — bump via env if fuller tracing wanted.
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
      ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string)
      : 0.1,
  });
  console.log('Sentry error tracking enabled (frontend)');
} else {
  console.log('VITE_SENTRY_DSN not set — Sentry error tracking disabled (no-op)');
}

export { Sentry };
export const sentryEnabled = Boolean(dsn);
